import React from 'react';
import styled from 'styled-components';

import { v4 as uuidv4 } from 'uuid';
import { NodeAIArgument } from '@components/Flow/Nodes';
import { AssistantToolArgument } from './AssistantToolArgument';
import { Box, Divider, Stack } from '@mui/material';
import { Button } from '@common/Button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 1rem;
`;

interface Props {
  toolArgsConfig: {
    toolArguments: NodeAIArgument[];
    setToolArguments: React.Dispatch<React.SetStateAction<NodeAIArgument[]>>;
  };
}

export const AssistantToolArguments: React.FC<Props> = ({ toolArgsConfig }) => {
  const { toolArguments, setToolArguments } = toolArgsConfig;

  const addArgument = () => {
    const arg = {
      id: uuidv4(),
      name: '',
      description: '',
      enumerator: '',
      type: 'string' as const,
    };

    setToolArguments((prevState) => prevState.concat(arg));
  };

  return (
    <Container>
      {toolArguments.length > 0 && (
        <Stack spacing={2} divider={<Divider flexItem />}>
          {toolArguments.map((argument) => (
            <AssistantToolArgument key={argument.id} toolArgument={argument} setToolArguments={setToolArguments} />
          ))}
        </Stack>
      )}
      <Box>
        <Button customColor='black' fullWidth onClick={addArgument}>
          Add Argument
        </Button>
      </Box>
    </Container>
  );
};
